import React from 'react'

import { Request } from 'src/types'
import { WrapCard } from '../../../../../styles'

import List from './list'

type Props = {
  request: Request
}

function SearchResultCard({ request }: Props) {
  return (
    <WrapCard
      data-test-id="vehicle-result"
      title="web.services.vehicle.search-result"
    >
      <List request={request} />
    </WrapCard>
  )
}

export default SearchResultCard
